
import ApiActions from '../../../actions/api';
import Constants from './constants';
import LoginStore from '../login/home/store';
import Qs from 'qs';
import Store from './store';
import ConfirmEmailStore from './confirm/store.js';

class Actions {
  static resetStore() {
    Store.dispatch({ type: Constants.RESET_STORE });
  }

  static async doSignup(data) {
    const response = await ApiActions.post(
      '/v1/signup',
      data,
      Store,
      Constants.REGISTER,
      Constants.REGISTER_RESPONSE
    );
    if (response.error) {
      window.dataLayer && window.dataLayer.push({
        'event':'customEvent',
        'eventCategory': 'signup',
        'eventAction': 'error',
        // Removed do to Google Analytics regulations.
        // 'eventLabel': data.email
      });

      return;
    }

    const account = response.data.account;
    const planId = account && account.signup_plan_id;

    if (account){
      // Only capture this event on success page.
      window.dataLayer && window.dataLayer.push({
        'event':'customEvent',
        'eventCategory': 'signup',
        'eventAction': 'success',
        // Removed do to Google Analytics regulations.
        // 'eventLabel': 'email', // data.email,
        'eventValue': planId,
      });
    }

    // Set a delay so we can send the GA call.
    setTimeout(function() {
      //updated to return account object
      if (response.data.emailVerified){
        //if user signed up and selected a plan about free Basic 0, it's a paid plan, direct them to the billing page to upgrade
        if (Number(planId)>0){
          window.location.href = '/account/plan';
        } else {
          window.location.href = '/account/';
        }
      } else {
        window.location.href = `/signup/success#email=${data.email}`;
      }
    }, 2000);
  }

  static async getUserCreds() {
    if (!global.window) {
      return;
    }
    const response = await ApiActions.get(
      '/v1/users/my',
      undefined,
      LoginStore,
      Constants.GET_USER_CREDS,
      Constants.GET_USER_CREDS_RESPONSE,
    );
    if (response.validation.error) {
      return;
    }
    const query = Qs.parse(window.location.search.substring(1));

    if (query.returnUrl && ApiActions.validateReturnURL(query.returnUrl)) {
      window.location.href = query.returnUrl;
    }
    else if (response.data && response.data.roles) {
      if (response.data.roles.admin) {
        window.location.href = '/admin';
      } else if (response.data.roles.account) {
        window.location.href = '/account';
      } else {
        // still need to signup, so stay at /signup
      }
    }
  }

  static async getPlanOptions() {
    await ApiActions.get(
      '/v1/accounts/map/plans',
      undefined,
      Store,
      Constants.GET_PLAN_OPTIONS,
      Constants.GET_PLAN_OPTIONS_RESPONSE,
    );
  }

  static async confirmEmail(data) {

    const response = await ApiActions.post(
      '/v1/signup/confirmEmail',
      data,
      ConfirmEmailStore,
      Constants.CONFIRM,
      Constants.CONFIRM_RESPONSE
    );

    if (response.error) {
      window.dataLayer && window.dataLayer.push({
        'event': 'customEvent',
        'eventCategory': 'confirmEmail',
        'eventAction': 'fail',
        // Removed do to Google Analytics regulations.
        // 'eventLabel': data && data.email,
      });

      return;
    }
    //updated to return account object
    if (response.data.alreadyVerified) {
      // this used to send ?email but it was not being used and was incorrectly sent to GA.
      window.location.href = '/login';
    } else if (response.data.emailVerified){
      window.dataLayer && window.dataLayer.push({
        'event': 'customEvent',
        'eventCategory': 'confirmEmail',
        'eventAction': 'success',
        // Removed do to Google Analytics regulations.
        // 'eventLabel': data && data.email,
      });
      const account = response.data.account;
      const planId = account && account.signup_plan_id;
      //if user signed up and selected a plan about free Basic 0, it's a paid plan, direct them to the billing page to upgrade
      if (Number(planId)>0){
        window.location.href = '/account/plan';
      } else {
        window.location.href = '/account/';
      }
    } else {
      window.location.href = `/signup/confirm#email=${data.email}`;
    }
  }
}

export default Actions;



// WEBPACK FOOTER //
// ./client/pages/main/signupAccountAPI/actions.js